/**
 * FamiliarisationNavigation - Navigation pills for familiarisation sections
 */

import React from 'react';
import { 
  CheckCircle, 
  Shield, 
  Users, 
  Settings, 
  Phone, 
  User, 
  FileText,
  PenTool,
  Clock
} from 'lucide-react';

const FamiliarisationNavigation = ({ 
  sections, 
  currentStep, 
  familiarisationComplete, 
  isTopicComplete, 
  onGoToTopic, 
  onGoToSignOff 
}) => {
  
  // Get topic icon
  const getTopicIcon = (topicId) => {
    const iconMap = {
      emergency_equipment: Shield,
      muster_evacuation: Users,
      role_specific_duties: User,
      vessel_systems: Settings,
      communication: Phone,
      safety_procedures: Clock,
      pre_sailing_familiarisation: Clock,
      emergency_equipment_procedures: Shield,
      vessel_systems_controls: Settings,
      task_specific_familiarisation: FileText,
      role_specific_procedures: User
    };
    const IconComponent = iconMap[topicId] || FileText;
    return <IconComponent size={16} />;
  };

  return (
    <div className="px-6 py-4 border-b bg-white">
      <div className="flex flex-wrap gap-2">
        {sections.map((section, index) => {
          const isActive = index === currentStep;
          const isCompleted = isTopicComplete(section.section);
          
          return (
            <button
              key={section.section}
              className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive 
                  ? 'bg-cyan-100 text-cyan-700 border border-cyan-200' 
                  : isCompleted
                  ? 'bg-green-50 text-green-700 hover:bg-green-100'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
              onClick={() => onGoToTopic(index)}
            >
              <span className="mr-2">
                {isCompleted ? <CheckCircle size={16} /> : getTopicIcon(section.section)}
              </span>
              <span className="hidden sm:inline">{section.title}</span>
              <span className="sm:hidden">{index + 1}</span>
              {section.mandatory && !isCompleted && (
                <span className="ml-1 text-red-500">*</span>
              )}
            </button>
          );
        })}
        
        {/* Master Sign-off Tab */}
        <button
          className={`inline-flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
            currentStep === sections.length 
              ? 'bg-cyan-100 text-cyan-700 border border-cyan-200'
              : familiarisationComplete
              ? 'bg-green-50 text-green-700 hover:bg-green-100'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
          onClick={onGoToSignOff}
        >
          <span className="mr-2">
            {familiarisationComplete ? <CheckCircle size={16} /> : <PenTool size={16} />}
          </span>
          <span className="hidden sm:inline">Sign-off</span>
          <span className="sm:hidden">✓</span>
        </button>
      </div>
    </div>
  );
};

export default FamiliarisationNavigation;